import { Target, MousePointerClick, Mail, Linkedin, UserCheck, Handshake } from "lucide-react";
import { METHOD } from "../content";
import { Reveal } from "../lib/motion";

const ICONS = [Target, MousePointerClick, Mail, Linkedin, UserCheck, Handshake];

export const Metodo = () => (
  <section
    id="metodo"
    data-testid="metodo-section"
    className="on-light bg-creme text-tinta py-20 md:py-28"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="label-caps text-azul mb-5">O fluxo Dealflow</p>
        <h2
          data-testid="metodo-title"
          className="headline text-3xl sm:text-4xl lg:text-5xl max-w-3xl"
        >
          Método: do clique ao contrato
        </h2>
      </Reveal>

      <div className="relative mt-14 md:mt-20">
        <div
          className="hidden lg:block absolute left-0 right-0 top-6 h-px bg-creamline"
          aria-hidden="true"
        />
        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5">
          {METHOD.map((m, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={m.step} delay={i * 0.08}>
                <li
                  data-testid={`method-stage-${m.step}`}
                  className="group relative h-full bg-creme border border-creamline p-6 hover:border-azul transition-colors duration-200"
                >
                  <div className="flex items-center justify-between">
                    <span className="w-12 h-12 flex items-center justify-center bg-tinta text-lima">
                      <Icon className="w-5 h-5" aria-hidden="true" />
                    </span>
                    <span className="font-sora font-extrabold text-azul text-sm tracking-[-0.02em]">
                      {m.step}
                    </span>
                  </div>
                  <h3 className="mt-6 font-sora font-bold text-lg tracking-[-0.03em]">
                    {m.title}
                  </h3>
                  <p className="mt-2 text-sm text-mutedlight leading-relaxed">{m.desc}</p>
                </li>
              </Reveal>
            );
          })}
        </ol>
      </div>

      <Reveal delay={0.15}>
        <p
          data-testid="metodo-closing"
          className="mt-14 md:mt-16 font-sora font-bold text-xl md:text-2xl tracking-[-0.035em] max-w-3xl"
        >
          Do clique ao contrato assinado,{" "}
          <span className="text-azul">sem o seu time perder tempo com lead frio.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
